module.exports = __webpack_public_path__ + "static/media/play-stone-boss-5-active.9a8baae2.png";